/**
 * Persists the public support form's idempotency key (`requestId`, a UUID)
 * across an ambiguous failed submit (network error / 5xx / timeout), so a
 * retry reuses the same key instead of risking a duplicate ticket. A brand
 * new id is only minted after a confirmed success or when the user
 * explicitly starts a fresh message.
 */
const STORAGE_KEY = "backpac.support.requestId";

function generateUuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID (older WebViews).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
    const random = (Math.random() * 16) | 0;
    const value = character === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function readStorage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function loadOrCreateSupportRequestId(): string {
  const storage = readStorage();
  const existing = storage?.getItem(STORAGE_KEY);
  if (existing != null && existing.length > 0) {
    return existing;
  }
  const created = generateUuid();
  storage?.setItem(STORAGE_KEY, created);
  return created;
}

export function createNewSupportRequestId(): string {
  const created = generateUuid();
  readStorage()?.setItem(STORAGE_KEY, created);
  return created;
}

export function clearSupportRequestId(): void {
  readStorage()?.removeItem(STORAGE_KEY);
}
